import { render, staticRenderFns } from "./CategoryQuizLayout.vue?vue&type=template&id=69246e51&scoped=true"
import script from "./CategoryQuizLayout.vue?vue&type=script&lang=js"
export * from "./CategoryQuizLayout.vue?vue&type=script&lang=js"
import style0 from "./CategoryQuizLayout.vue?vue&type=style&index=0&id=69246e51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69246e51",
  null
  
)

export default component.exports